<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('detail') }}</v-toolbar-title>
      <v-checkbox
        v-model="status"
        class="mt-6 mx-4"
        :label="$t('status') + '  :  ' + (status ? $t('active') : $t('deactive'))"
        value="active"
      />
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo(type)"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type) }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo(type + 'List')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t(type + 'List') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-text-field
              v-model="name"
              :label="$t('name')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
          >
            <autocomplete
              v-model="group"
              :rules="[v => !!v || $t('is-required')]"
              :title="$t('detailGroup')"
              type="detailGroup"
              :value="group"
              :disabled="(id ? true : false)"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            class="mb-0  "
          >
            <autocomplete
              v-model="system"
              :title="$t('systemLink')"
              :value="system"
              :data="JSON.stringify({type : 'detail'})"
              type="system"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
          >
            <tag
              v-model="tag"
              :solo="false"
              :input="tag"
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <description
              ref="refContent"
              v-model="content"
              :outlined="true"
              type="sell"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              v-if="!formType"
              color="grey"
              outlined
              class="float-left"
              @click="goTo( 'detailList' )"
            >
              {{ $t('detailList') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
  // import aicomplete from '../../components/general/AIcomplete/index'
  import General from '../../../../Mixins/general'
  import Description from '../../components/general/description/Description'
  export default {
    name: 'Product',
    components: {
      autocomplete: () => import('../../components/general/patial/autocomplete'),
      // aicomplete,
      Description,
      Tag: () => import('../../components/general/Tag/tag'),
    },
    mixins: [General],
    props: ['formType', 'returnObject'],
    data: () => ({
      options: {
        locale: 'en-US',
        prefix: '',
        suffix: ' ',
        precision: 0,
      },
      render: false,
      isLoading: false,
      alert: false,
      system: null,
      tag: null,
      content: null,
      valid: null,
      message: null,
      alertType: null,
      name: null,
      type: null,
      id: null,
      status: 'active',
      group: null,
      loading: false,
    }),
    watch: {
    },
    beforeMount () {
      if (this.$route.params.id != null) {
        this.show()
        this.id = this.$route.params.id
        this.render = false
      } else {
        this.render = true
      }
    },
    mounted () {
    },
    methods: {
      create () {
        var app = this
        app.alert = false
        app.isLoading = true
        app.$axios.post(this.$endpoint + 'detail', app.$data)
          .then(res => {
            if (app.id) {
              app.goTo('detailList')
            } else {
              app.$emit('input', res.data.data)
              app.snakbarText = app.$t('registered')
              app.snakbarColor = 'green'
              app.snakbar = true
            }
          })
          .catch(err => {
            this.serverErrorHandeler(err)
          })
          .finally(() => {
            this.isLoading = false
            this.clearForm()
          })
      },
      show () {
        var app = this
        app.clearForm()
        app.loading = true
        app.clearing = true
        app.showing = true
        app.$axios.get(this.$endpoint + 'detail/' + this.$route.params.id + '/edit', {
          params: {
            id: this.$route.params.id,
          },
        })
          .then(res => {
            res = res.data
            app.$nextTick(() => {
              app.id = res.id
              app.name = res.name
              app.system = res.system
              app.group = res.group
              app.content = res.content
              if (res.tags) {
                app.tag = res.tags
              }
              app.render = true
            })
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.loading = false))
      },
      update () {
        var app = this
        app.isLoading = true
        app.$axios.put(this.$endpoint + 'detail/' + this.$route.params.id, this.$data)
          .then(res => {
            res = res.data
            app.$emit('close', app.$route)
            app.goTo('detailList')
          })
          .catch(err => {
            app.serverErrorHandeler(err)
          })
          .finally(() => (app.isLoading = false))
      },
      clearForm () {
        this.tag = null
        this.content = null
        this.name = null
        this.system = null
        this.id = null
        this.status = 'active'
        this.type = null
        this.group = null
      },
    },
  }
</script>

<style scoped>

</style>
